import { createSelector } from 'reselect';
import { createDisplayLayoutSelector } from './display-layout-selector.esm.js';

var selectedFields = function selectedFields(currentLayout) {
  return currentLayout.fields || [];
};
var createSelectedFieldsSelector = function createSelectedFieldsSelector() {
  var displayLayoutSelector = createDisplayLayoutSelector();
  return createSelector(displayLayoutSelector, selectedFields);
};

export { createSelectedFieldsSelector, selectedFields };
//# sourceMappingURL=selected-fields-selector.esm.js.map
